/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.contentEditorModule')
.controller('ImageBlockController', ['$scope', 'CONFIG', 'CONTENT_EDITOR', ImageBlockController]);

/**
 *
 */
function ImageBlockController($scope, CONFIG, CONTENT_EDITOR) {
  var that = this;

  // TODO CLEAN : perhaps do a watch on contentBlock or something like that instead?  Since assets can't change,
  // we could watch the contentBlock asset ids via watchGroup
  this.updateImageInfo = function(imageAsset) {
    var contentSize = jQuery('.bulb-page-content').width();
    var maxSize = CONFIG.page.content.max.width;
    var contentScale = contentSize/maxSize;
    // TODO ISSUE : handle resize event

    var displayedImageAsset = imageAsset || $scope.contentBlockCtrl.contentBlock.scaledImageAsset ||
                        $scope.contentBlockCtrl.contentBlock.fullImageAsset;

    var imageWidth = displayedImageAsset.width;
    var imageHeight = displayedImageAsset.height;
    var imageScale = 1;

    // If we are displaying an image larger than the content maxWidth, scale it down to fix.  Typically only
    // necessary when re-cropping an image, since other images fit within the content maxWidth.
    if (imageWidth > maxSize) {
      imageScale = maxSize/imageWidth;
      imageWidth = maxSize;
      imageHeight = imageHeight * imageScale;
    }
    that.url = displayedImageAsset.url;
    that.width = imageWidth * contentScale;
    that.height = imageHeight * contentScale;
    that.maxWidth = displayedImageAsset.width;
    that.photoMetaInfo = displayedImageAsset;
    that.MINIMUM_IMAGE_WIDTH = CONTENT_EDITOR.MINIMUM_IMAGE_WIDTH;

    // Determines if the width of the image block is too high for what we allow when putting content to the right
    // or left of the block on a right/left align.
    $scope.contentBlockCtrl.isFullWidth = (imageWidth > (maxSize * CONTENT_EDITOR.FULL_BLOCK_WIDTH_PERCENTAGE));
  };

  $scope.$watchCollection('contentBlockCtrl.contentBlock', function() {
    that.updateImageInfo();
  });
}


